const STRING = "STRING";
const URL = "URL";
const IMAGE = "IMAGE";

export default {
  STRING,
  URL,
  IMAGE
};
